export const ERRORS = {
  REFERRAL_CODE_NOT_FOUND: 'Code is not found',
  REFERRAL_CODE_EXIST: 'This code already exists',
  LINK_TO_YOURSELF: 'Cannot set yourself as a referral',
  AGENT_EXIST_UP: 'The agent already exists higher in the hierarchy tree',
  AGENT_EXIST_DOWN: 'The agent already exists below in the hierarchy tree',
  RECOMMENDER_EXIST_UP: 'The assistant already exists higher in the hierarchy tree',
  RECOMMENDER_EXIST_DOWN: 'The assistant already exists below in the hierarchy tree',
  TYPE_EXIST: 'The type already exists',
  WRONG_FORMAT: 'Only .jpg, .jpeg and .png formats can be uploaded',
  SMS_CODE_LIMIT_EXCEEDED: 'SMS codes limit has been exceeded. Please, try again in an hour',
  THE_NUMBER_IS_NOT_CORRECT: 'Sort order number is not correct',
  NAME_EXIST: 'The name already exists',
  CONTRACT_PRODUCT_EXIST: 'Product with this contract number already exists',
  INVESTOR_NOT_FOUND: 'Account not found',
  CONFIRM_CODE_IS_WRONG: 'Wrong code',
  CONFIRM_CODE_EXPIRED: 'Code is expired',
  IS_SAME_PASSWORD: 'Make a different password',
  NAME_NO_VALID: 'First name and/or last name are invalid'
};
